import { ContainerModule } from 'inversify';
import type { IIndicationsFactory } from './Indications.factory';
import { IndicationsFactory } from './Indications.factory';
import { IndicationsService } from './Indications.service';

import { TYPES } from './iocTypes';
import { BoxesIndicationStore } from '@/components/boxes/BoxesIndicationStore.ts';
import { ToolSelectorController } from './ToolSelector.controller';
import { ToolsManagerFactory } from './ToolsManager.factory';
import { ToolStateStore } from './ToolStateStore';
import { AnnotationTwoDController } from './annotation/AnnotationTwoDController';
import { IndicationsViewModelFactory } from './IndicationsViewModel.factory';
import type { IIndicationsViewModelFactory } from './interfaces';
import { IndicationsCommandsFactory } from './commands/IndicationsCommands.factory';
import { RemoveIndicationCommandsFactory } from './commands/RemoveIndicationCommands.factory';
import type { IRemoveCommandsFactory } from './IndicationRemoveHighlighter';

export const indicationModule = new ContainerModule((bind) => {
  bind<ToolStateStore>(TYPES.ToolStateStore).to(ToolStateStore).inSingletonScope();
  bind<BoxesIndicationStore>(TYPES.BoxesIndicationStore).to(BoxesIndicationStore).inSingletonScope();

  bind<ToolSelectorController>(TYPES.ToolSelectorController).to(ToolSelectorController);

  bind<ToolsManagerFactory>(TYPES.ToolsManagerFactory).to(ToolsManagerFactory);
  bind<IIndicationsFactory>(TYPES.IIndicationsFactory).to(IndicationsFactory);
  bind<IIndicationsViewModelFactory>(TYPES.IIndicationsViewModelFactory).to(IndicationsViewModelFactory);
  bind<IndicationsService>(TYPES.IndicationsService).to(IndicationsService);
  bind<AnnotationTwoDController>(TYPES.AnnotationTwoDController).to(AnnotationTwoDController).inSingletonScope();
  bind<IndicationsCommandsFactory>(TYPES.IndicationsCommandsFactory).to(IndicationsCommandsFactory);
  bind<IRemoveCommandsFactory>(TYPES.RemoveIndicationCommandsFactory).to(RemoveIndicationCommandsFactory);
});
